export const FormatRupiahCurrency = (amount) => {
  let number_string = amount.toString(),
    sisa = number_string.length % 3,
    rupiah = number_string.substr(0, sisa),
    ribuan = number_string.substr(sisa).match(/\d{3}/g);

  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  return rupiah;
};

import React from "react";
import { i18n } from "@lingui/core";

export function NumberFormat(props) {
  const { value } = props;

  return i18n.number(value, {
    currency: "IDR",
    style: "currency",
    maximumFractionDigits: 0,
  });
}

export function DollarNumberFormat(props) {
  const { value } = props;

  return i18n.number(value, {
    currency: "USD",
    style: "currency",
    minimumFractionDigits: 0,
  });
}
